export default __webpack_public_path__ + "static/media/soup.404ed81c.svg";